import { Line } from "./types";

// What an invoice line's row shows, and its edit row edits. A change to
// anything else (its status moving on, say) is no change to what the user was
// editing.
const SHOWN_FIELDS = [
  "productId",
  "unitId",
  "description",
  "quantity",
  "amount",
  "percentage",
  "discountPercentage",
] as const;

export type LineField = (typeof SHOWN_FIELDS)[number];

export type RemoteLineChanges = {
  // Per line, the shown fields that differ.
  changed: Record<string, LineField[]>;
  deleted: string[];
};

/**
 * How the delivery's lines changed between what the dialog had and what it
 * refetched after someone else changed the delivery. Added lines are left out:
 * nobody can be editing them.
 */
export const remoteLineChanges = (
  before: readonly Line[],
  after: readonly Line[]
): RemoteLineChanges => {
  const afterById = new Map(after.map((line) => [line.id, line]));
  const changed: Record<string, LineField[]> = {};
  const deleted: string[] = [];
  for (const line of before) {
    const now = afterById.get(line.id);
    if (!now) {
      deleted.push(line.id);
      continue;
    }
    const fields = SHOWN_FIELDS.filter((field) => line[field] !== now[field]);
    if (fields.length) {
      changed[line.id] = fields;
    }
  }
  return { changed, deleted };
};
